import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import PrintViewKnowledgeDescription from './PrintViewKnowledgeDescription';
import CanvasFormInputDisplay from '../../../../Common/CanvasForm/CanvasFormInputDisplay';
import CanvasFormInputValue from '../../../../Common/CanvasForm/CanvasFormInputValue';

export const PrintViewSingleLineInputBody = ({body}) => {
	const {bodyFreeText, label, name} = body;

	return (
		<StyledPrintViewSingleLineInputBody className="StyledPrintViewSingleLineInputBody">
			{body && body.id > 0 && <PrintViewKnowledgeDescription body={body} bodyDescription={name} />}
			<CanvasFormInputDisplay
				bodyFreeText={bodyFreeText}
				value={bodyFreeText}
				label={label}
				isReadOnly
				className="single-line"
			>
				<CanvasFormInputValue />
			</CanvasFormInputDisplay>
		</StyledPrintViewSingleLineInputBody>
	);
};

PrintViewSingleLineInputBody.propTypes = {
	body: PropTypes.shape({
		bodyFreeText: PropTypes.string,
		label: PropTypes.string,
		name: PropTypes.string
	})
};

PrintViewSingleLineInputBody.defaultProps = {};

export default PrintViewSingleLineInputBody;

const StyledPrintViewSingleLineInputBody = styled.section`
	.StyledPrintViewKnowledgeDescription {
		margin-bottom: var(--px-10);
	}
	.canvas-form-input-text {
		width: var(--px-200);
		height: var(--px-30);
		padding: var(--px-2) var(--px-8);
		border: 1px solid var(--neutrals-300);
		font-size: var(--px-12);
	}
`;
